var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdministration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4129_4341)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4129_4341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.79487 3.80012C1.79487 2.13099 3.16098 0.777893 4.84615 0.777893C6.53133 0.777893 7.89744 2.13099 7.89744 3.80012C7.89744 5.46924 6.53133 6.82234 4.84615 6.82234C3.16098 6.82234 1.79487 5.46924 1.79487 3.80012Z",
    fill: "#0BA5EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91762 8.18711L3.04549 8.16689C4.23838 7.97833 5.45392 7.97833 6.64682 8.16689L6.77468 8.18711C8.45552 8.4528 9.69231 9.88882 9.69231 11.5747C9.69231 12.4847 8.94755 13.2223 8.02884 13.2223H1.66346C0.744758 13.2223 0 12.4847 0 11.5747C0 9.88882 1.23679 8.4528 2.91762 8.18711Z",
    fill: "#0BA5EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15385 0.777893C8.85646 0.777893 8.61539 1.01667 8.61539 1.31123C8.61539 1.60578 8.85646 1.84456 9.15385 1.84456C10.2443 1.84456 11.1282 2.72009 11.1282 3.80012C11.1282 4.88014 10.2443 5.75567 9.15385 5.75567C8.85646 5.75567 8.61539 5.99445 8.61539 6.289C8.61539 6.58356 8.85646 6.82234 9.15385 6.82234C10.839 6.82234 12.2051 5.46924 12.2051 3.80012C12.2051 2.13099 10.839 0.777893 9.15385 0.777893Z",
    fill: "#0BA5EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0449 8.16023C9.74756 8.16023 9.50648 8.39901 9.50648 8.69356C9.50648 8.98811 9.74756 9.2269 10.0449 9.2269H10.74C10.7978 9.2269 10.8557 9.23143 10.9127 9.24044C12.0709 9.42352 12.9231 10.413 12.9231 11.5747C12.9231 11.8956 12.6605 12.1557 12.3365 12.1557H10.8696C10.5723 12.1557 10.3312 12.3945 10.3312 12.689C10.3312 12.9836 10.5723 13.2223 10.8696 13.2223H12.3365C13.2552 13.2223 14 12.4847 14 11.5747C14 9.88882 12.7632 8.4528 11.0824 8.18711C10.9691 8.16921 10.8546 8.16023 10.74 8.16023H10.0449Z",
    fill: "#0BA5EC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4129_4341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4129_4341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministration);
export default __webpack_public_path__ + "static/media/administration.145f21e3e4a5295dc6acf0b19aa68ceb.svg";
export { ForwardRef as ReactComponent };